import * as actionTypes from "./constants";
import { removeHours, isToday } from "../../utils/helpers/date";
import axios from "axios";
import moment from "moment";
import { isSynchronizing } from "../../users/selectors";
import { getSyncedOccupancy } from "../../synchronization/actions";

export const incrementDate = () => {
  return (dispatch, getState) => {
    const { date } = getState().occupancy;
    const tmpDate = date.clone();
    const today = moment.utc();
    removeHours(tmpDate);
    removeHours(today);

    const nextDay = tmpDate.add(1, "days");

    if (nextDay > today.add(7, "days")) return;
    dispatch({ type: actionTypes.INCREMENT_DATE, date: nextDay });
  };
};

export const decrementDate = () => {
  return (dispatch, getState) => {
    const { date } = getState().occupancy;
    const tmpDate = date.clone();
    const today = moment.utc();

    removeHours(tmpDate);
    removeHours(today);

    const previousDay = tmpDate.subtract(1, "days");
    if (today > previousDay) return;
    dispatch({ type: actionTypes.DECREMENT_DATE, date: previousDay });
  };
};

export const getOccupancy = () => {
  return (dispatch, getState) => {
    if (isSynchronizing(getState())) {
      dispatch(getSyncedOccupancy());
    } else {
      dispatch(getOccupnacies());
    }
  };
};

export const getOccupnacies = () => {
  return (dispatch, getState) => {
    const hotelId = getState().hotels.selected;
    const { date } = getState().occupancy;
    dispatch({
      type: actionTypes.GET_OCCUPANCIES_REQUEST
    });
    return axios
      .get("/room-info", {
        params: {
          hotelId,
          date: removeHours(date).format()
        }
      })
      .then(response => {
        dispatch({
          type: actionTypes.GET_OCCUPANCIES_SUCCESS,
          occupancies: response.data
        });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_OCCUPANCIES_REJECT,
          err
        });
      });
  };
};

export const createOccupancy = occupancy => {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.CREATE_OCCUPANCY_REQUEST
    });
    return axios
      .post("/room-info", occupancy)
      .then(response => {
        dispatch({
          type: actionTypes.CREATE_OCCUPANCY_SUCCESS,
          occupancy: response.data
        });
        const { socket } = getState().messages;
        socket.emit("room:add-room-info", response.data);
      })
      .catch(err => {
        dispatch({
          type: actionTypes.CREATE_OCCUPANCY_REJECT,
          err
        });
      });
  };
};

export const editOccupancy = occupancy => {
  return dispatch => {
    dispatch({
      type: actionTypes.EDIT_OCCUPANCY_REQUEST
    });
    return axios
      .put(`/room-info/${occupancy.roomInfoId}`, occupancy)
      .then(response => {
        dispatch({
          type: actionTypes.EDIT_OCCUPANCY_SUCCESS,
          occupancy: occupancy
        });
      })
      .catch(err => {
        dispatch({
          type: actionTypes.EDIT_OCCUPANCY_REJECT,
          err
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/rooms/occupancy/actions.js